import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FIELDS_CONSTANT } from '@sharedModule/constants/fields.constant';
import { InputData } from '@sharedModule/models/input-data.model';

@Component({
  selector: 'app-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
})
export class ValidationErrorComponent {
  @Input() control!: FormControl | undefined;
  @Input() inputData?: InputData;
  public messageConstant = FIELDS_CONSTANT.message;
}
